// Generated by copy-types.sh from langwatch/src/server/modelProviders/llmModels.json
// Do not edit by hand — re-runs on every SDK install/build.
export const DEFAULT_PROMPT_MODEL = "openai/gpt-5.5";
